<template>
  <div>
    <!-- Workflows feature removed -->
  </div>
</template>


<script>
export default {
  // Workflows feature removed
};
</script>

<style></style>



